export const TOKEN_KEY = "PalmaTrackerToken";
export const USERDATA = "PalmaTrackerUser";

export const isAuthenticated = () => {
  const token = getCookie('PalmaTrackerToken');
  return token !== "";
};

export const getToken = () => {
  const token = getCookie('PalmaTrackerToken');
  console.debug("getToken",token);
  return token;
};

export const getUser = () => {
  const user = getCookie('PalmaTrackerUser');
  if (user !== "") {
    return JSON.parse(user); 
  } else {
    return null;
  }
};

export const getCookie = (cname) => {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}